import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import DetailsIcon from "../svg/user.svg";
import { useNotification } from "../../Notifications/NotificationProvider";

const DetailsCardItem = ({
  index,
  label,
  value,
  icon,
  avatar,
  subValue,
  extraInfo,
  copyable = false,
  editable = false,
  onEdit,
  editableFields = [],
  onEditingStateChange,
}) => {
  const [isEditingField, setIsEditingField] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const [editSubValue, setEditSubValue] = useState(subValue);

  const localUserType = JSON.parse(localStorage.getItem("currUserType"));
  const canEdit = editable && localUserType === "cs_user_layer_1";
  const isFieldEditable = canEdit && editableFields.includes(label);
  const dispatchNotification = useNotification();
  const handleEdit = () => {
    setIsEditingField(true);
    setEditValue(value);
    setEditSubValue(subValue);
    if (onEditingStateChange) {
      onEditingStateChange(true);
    }
  };

  const handleSave = () => {
    if (onEdit) {
      onEdit(label, editValue, editSubValue);
    }
    setIsEditingField(false);
    if (onEditingStateChange) {
      onEditingStateChange(false);
    }
  };

  const handleCancel = () => {
    setIsEditingField(false);
    setEditValue(value);
    setEditSubValue(subValue);
    if (onEditingStateChange) {
      onEditingStateChange(false);
    }
  };

  const copyToClipboard = async (text) => {
    if (!text && text !== "") return false;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {
        try {
          const textarea = document.createElement("textarea");
          textarea.value = text;
          textarea.setAttribute("readonly", "");
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand("copy");
          document.body.removeChild(textarea);
          return successful;
        } catch {
          return false;
        }
      }
    }
  };

  const handleCopy = async () => {
    const ok = await copyToClipboard(value);
    if (ok) {
      dispatchNotification({
        type: "SUCCESS",
        message: `${label} copied to clipboard`,
      });
    } else {
      dispatchNotification({
        type: "ERROR",
        message: `Failed to copy ${label}`,
      });
    }
  };

  return (
    <div className="icon-details-item">
      <div className="icon-details-container">
        <img
          src={icon || DetailsIcon}
          alt="Icon"
          className="icon-details-icon"
        />
      </div>

      <div className="icon-details-text">
        <p className="icon-details-label">{label}</p>

        {isEditingField ? (
          <div className="edit-mode">
            <div className="edit-fields">
              <input
                type="text"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                className="edit-input"
                placeholder={label}
              />
              {subValue && (
                <input
                  type="text"
                  value={editSubValue}
                  onChange={(e) => setEditSubValue(e.target.value)}
                  className="edit-input edit-input-sub"
                  placeholder="Additional info"
                />
              )}
            </div>
            <div className="edit-actions">
              <button className="edit-action-btn save-btn" onClick={handleSave}>
                <CheckIcon fontSize="small" />
              </button>
              <button
                className="edit-action-btn cancel-btn"
                onClick={handleCancel}
              >
                <CloseIcon fontSize="small" />
              </button>
            </div>
          </div>
        ) : (
          <div className="view-mode">
            {avatar && (
              <img src={avatar} alt="Avatar" className="avatar-image" />
            )}
            <div className="value-container">
              <div className="value-row">
                <p
                  className={`${copyable ? "copyable" : "icon-details-value"}`}
                  onClick={copyable ? handleCopy : undefined}
                  title={copyable ? "Click to copy" : undefined}
                >
                  {value || "N/A"}
                  {copyable && value && (
                    <ContentCopyIcon
                      style={{ fontSize: 14, color: "#E2136E", marginLeft: 8 }}
                    />
                  )}
                </p>
                {isFieldEditable && (
                  <button className="edit-btn" onClick={handleEdit}>
                    <EditIcon fontSize="small" />
                  </button>
                )}
              </div>

              {subValue && <p className="icon-details-sub-value">{subValue}</p>}

              {extraInfo && (
                <p className="icon-details-extra-info">{extraInfo}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailsCardItem;
